// ** React Imports
import { useState, useEffect, SyntheticEvent, useMemo } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Card,
    Container,
    Divider,
    Stack,
    TextField,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import { useToast } from '../../../components/ToastProvider';

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const [listData, setListData] = useState<any[]>([])
    const [search, setSearch] = useState('');

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        showToast("Loading...", "loading");
        let url = apiUrl.apiUrl + '/report/production-board/list'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    setListData(data)
                    hideToast();
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    const filteredData = useMemo(() => {
        if (!search) return listData;

        const keyword = search.toLowerCase();

        return listData.filter(
            (item: any) =>
                item.wo.toString().includes(keyword) ||
                item.product.toLowerCase().includes(keyword)
        );
    }, [listData, search]);

    const CARD_FIELDS = [
        's1', 's2', 's3', 's4', 's5',
        's6', 's7', 's8', 's9', 's10',
    ] as const;

    const renderMultilineText = (text?: string) => {
        if (!text) return null;

        return text.split('\n').map((line, index) => (
            <span key={index}>
                {line}
                <br />
            </span>
        ));
    };

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='PRODUCTION BOARD' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                            <Button
                                variant='contained'
                                startIcon={<Icon icon='mdi:magnify' />}
                                onClick={() => getData()}
                            >
                                Refresh Data
                            </Button>
                        </Box>
                        <Container maxWidth={false} sx={{ py: 3 }}>
                            <Box mb={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Cari WO / Product"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </Box>

                            <Stack spacing={3}>
                                {filteredData.map((item: any) => (
                                    <Box
                                        key={item.id}
                                        sx={{
                                            position: 'relative',
                                        }}
                                    >
                                        <Stack direction="row" spacing={2}>
                                            <Card
                                                variant="outlined"
                                                sx={{
                                                    width: 300,
                                                    height: 300,
                                                    position: 'sticky',
                                                    left: 0,
                                                    zIndex: 5,
                                                    flexShrink: 0,
                                                    backgroundColor: 'primary.main',
                                                    color: 'white',
                                                    borderRadius: 3,
                                                }}
                                            >
                                                <CardContent
                                                    sx={{
                                                        height: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'left',
                                                        textAlign: 'left',
                                                        p: 1.5,
                                                    }}
                                                >
                                                    <Typography fontWeight="bold">WO :</Typography>
                                                    <Typography>{item.wo}</Typography>

                                                    <Typography fontWeight="bold" mt={1}>
                                                        Product :
                                                    </Typography>
                                                    <Typography fontSize={13}>
                                                        {item.product}
                                                    </Typography>

                                                    <Stack mt={2} spacing={0.5}>
                                                        <Typography fontSize={13}>
                                                            Tgl: {item.tgl}
                                                        </Typography>
                                                        <Typography fontSize={13}>
                                                            Deadline: {item.deadline ?? '-'}
                                                        </Typography>
                                                        <Typography fontSize={13}>
                                                            Total Hari: {item.total_hari}
                                                        </Typography>
                                                    </Stack>
                                                </CardContent>
                                            </Card>

                                            <Box sx={{ overflowX: 'auto' }}>
                                                <Stack direction="row" spacing={2}>
                                                    {CARD_FIELDS.map((field) => (
                                                        <Card
                                                            key={field}
                                                            variant="outlined"
                                                            sx={{
                                                                width: 220,
                                                                height: 300,
                                                                borderRadius: 3,
                                                                flexShrink: 0,
                                                                borderColor: '#212121',
                                                            }}
                                                        >
                                                            <CardContent
                                                                sx={{
                                                                    height: '100%',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    justifyContent: 'left',
                                                                    textAlign: 'left',
                                                                    p: 1.5,
                                                                }}
                                                            >
                                                                {item[field] ? (
                                                                    item[field]!.split('\n').map((line: any, i: any) => (
                                                                        <Typography key={i} fontSize={14}>
                                                                            {line || '\u00A0'}
                                                                        </Typography>
                                                                    ))
                                                                ) : (
                                                                    <Typography
                                                                        fontSize={12}
                                                                        color="text.secondary"
                                                                        textAlign="center"
                                                                    >
                                                                        -
                                                                    </Typography>
                                                                )}
                                                            </CardContent>
                                                        </Card>
                                                    ))}
                                                </Stack>
                                            </Box>
                                        </Stack>
                                    </Box>
                                ))}

                                {filteredData.length === 0 && (
                                    <Typography textAlign="center" color="text.secondary">
                                        Data tidak ditemukan
                                    </Typography>
                                )}
                            </Stack>
                        </Container>

                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}